import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DashboardParams, DatasetValue, GraphDataValue } from 'src/app/models/dashboardParams';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { UserService } from '../../../shared/user.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  theme_color: string;
  userStatistics: any;
  dataValues: any;
  dashboardParams = new DashboardParams();
  diskUsageStatistics: number = 0;
  loggedInUserStatistics: any;
  uploadStatistics: any;
  downloadStatistics: any;
  applicationResponseTime: any;
  @ViewChild('widgetContent') widgetContentt: ElementRef;

  constructor(private httpService: HttpService, private userService: UserService, public dashboardService: DashboardService) {
    this.httpService.themeChange.subscribe(
      theme => {
        this.theme_color = theme.themeType;
      }
    );
    if (this.httpService.basePath === "")
      this.httpService.getBasePath();
    this.dashboardService.basePath = this.httpService.basePath;
    this.getLoggedInUserStatistics();
  }
  ngOnInit() {

    this.getUserActivity();
    this.getUploadStatistics();
    this.getDownloadStatistics();
    this.getApplicationResponseTime();
    this.getDiskUsage();
  }

  getUserActivity() {
    this.userService.getUserStatistics().subscribe(
      data => {
        this.userStatistics = data;
      });
  }

  getLoggedInUserStatistics() {
    this.dashboardService.getLoggedInUserStatistics(this.dashboardParams).subscribe(
      data => {
        this.loggedInUserStatistics = this.setGraphValues(data);
      },
      error => {
        // Notification Popup
        console.log("error occured in dashboard");
      }
    );
  }

  getUploadStatistics() {
    this.dashboardService.getUploadStatistics().subscribe(
      data => {
        this.uploadStatistics = this.setGraphValues(data);
      },
      error => {
        console.log("error occured in dashboard");
      }
    );
  }
  getDiskUsage() {
    this.dashboardService.getDiskUsageStatistics().subscribe(
      (data: number) => {
        this.diskUsageStatistics = data;
      },
      error => {
        console.log("Error Occured While Fetching Data. Try Again");
      }
    );
  }
  getDownloadStatistics() {
    this.dashboardService.getDownloadStatistics().subscribe(
      data => {
        this.downloadStatistics = this.setGraphValues(data);
      }
    );
  }

  getApplicationResponseTime(filterValue = 'min') {
    this.dashboardService.getApplicationResponseTime(this.dashboardParams).subscribe(
      data => {
        this.applicationResponseTime = this.setGraphValues(data);
      }
    );
  }
  onFilterSelected(filterValue: string) {
    this.dashboardParams.filterSelected = filterValue;
    this.getLoggedInUserStatistics();
  }

  onApplicationFilterSelected(filterValue: string) {
    this.dashboardParams.applicationResponseFilter = filterValue;
    this.getApplicationResponseTime();
  }
  setGraphValues(res: any) {
    let dataVariable: any;
    dataVariable = {
      labels: res.x,
      datasets: [
        {
          label: "VAL",
          data: res.y
        }
      ]
    };
    return dataVariable;
  }
  scrollLeft() {
    this.widgetContentt.nativeElement.scrollLeft -= 250;
  }
  scrollRight() {
    this.widgetContentt.nativeElement.scrollLeft += 250;
  }
}


